import * as React from "react"

import {cn} from "@/lib/utils"

export interface InputProps
  extends React.InputHTMLAttributes<HTMLTextAreaElement> {
}

const Textarea = React.forwardRef<HTMLTextAreaElement, InputProps>(
  ({ className, ...props}, ref) => {
    return (
      <div className='relative'>
        <textarea
          className={cn(
            "flex w-full rounded-md border border-input bg-neutral-50 px-3 py-4 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
            className
          )}
          ref={ref}
          {...props}
        />
      </div>
    )
  }
)
Textarea.displayName = "Textarea"

export {Textarea}
